
<template>
    <div class="panel-container show">
        <div class="panel-content">
            <fileloader
                :files="loaded_files"
                :enable-preview=false
                :validate_geo="false"
                :can_del="true"
                key="file_loader_mem"
                doc_type="internaldoc"
                :doc_id="doc.id"
                v-bind:trigger_load="load_trigger"
            >
            </fileloader>
        </div>
        
        <div>
            <b-table class="table-responsive-lg"    striped  :items="doc.files" :fields="fields">
                
                <template  v-slot:head(link)="data">
                    <span class="fs-xl text-center" v-html="data.label"></span>
                </template>
                
                <template  v-slot:head(id)="data">
                    <span class="fs-xl text-center" v-html="data.label"></span>
                </template>
                
                <template  v-slot:cell(link)="data" >
                    <span class="get_file cursor-pointer" @click="get_file(data.item)">
                         <i class="fal fs-xl  fa-save save_me"></i>
                    </span>
                </template>
                
                <template  v-slot:cell(id)="data" >
                    <span class="get_file cursor-pointer" @click="remove_file(data.item)">
                         <i class="fal fs-xl  fa-trash save_me"></i>
                    </span>
                </template>
                
            </b-table>
        </div>
        
    </div>
</template>

<script>
import fileloader from "../../../../shared/file_loader/fileloader.vue";

export default {
    name: "internal_files",
    components: {fileloader},
    props : {
        doc : {
            type : Object
        }
    },
    
    created() {
        EventBus.$on(this.load_trigger,this.work_files)
    },
    
    data() {
        return {
            loaded_files : [],
            load_trigger:  "loader_load_file_internal",
            fields: [
                {
                    key: 'name',
                    label: 'Назва',
                    sortable: true
                },
                {
                    key: 'added_human',
                    label: 'Дата',
                    sortable: true
                },
                {
                    key : 'link',
                    label: '<i class="fal fa-save"></i>',
                    sortable: false
                },
                {
                    key: 'id',
                    label: '<i class="fal fa-trash"></i>',
                    sortable: true
                },
                
            ],
        }
    },
    
    methods : {
        
        async remove_file(item) {
            console.log(item);
            await api.delete(  '/files/' + item.id,{
                'remove_type' : 'remove'
            }).then(({data}) => {
                if (data.status === "operation_success") {
                    this.doc.files = this.doc.files.filter(file => {
                         return parseInt(file.id) != parseInt(item.id);
                    });
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.status})
                console.log(err);
            });
        },
        
        get_file(item) {
            IMC_CORE.showloading();
            api.get('/files/' + item.id, { responseType: 'blob' })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        const fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', item.name);
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        document.body.removeChild(fileLink);
                    } else {
                        EventBus.$emit('show_toast', { err: 'File not found', type: "danger", title: 'Error' });
                    }
                })
                .catch(err => {
                    EventBus.$emit('show_toast', { err: err.message, type: "danger", title: err.name });
                })
                .finally(() => {
                    IMC_CORE.hideloading();
                });
        },
        
        work_files(event) {
            let self = this;
            console.log(event);
            if (event != undefined) {
                if(event.hasOwnProperty('type')) {
                    if (event.type === 'file_loaded') {
                        event.id = event.file_id;
                        if(event.hasOwnProperty("full_file")) {
                            self.doc.files.push(event.full_file);
                        }
                    }
                    
                    if (event.type === 'file_deleted') {
                        this.doc.files = this.doc.files.filter(file => {
                            return parseInt(file.id) != parseInt(event.file_id);
                        });
                    }
                }
            }
        },
    },
    computed: {
        cur_files() {
            if(this.doc.hasOwnProperty("files")) {
                return this.doc.files.map(file => {
                    file.file_id = file.id;
                    return file;
                });
            }
            return [];
        },
    }
    
    
  
}
</script>


<style scoped>

</style>